import { render, staticRenderFns } from "./PendingBookings.vue?vue&type=template&id=d7cd5ce2"
import script from "./PendingBookings.vue?vue&type=script&lang=js"
export * from "./PendingBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports